//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/PcbExchange.js";
import "../no/Builder.js";
import "../no/Expression.js";
import "../no/SelectNXObjectList.js";
import "../no/Expression.js";
import "../no/SelectObjectList.js";
let d=[[[0,"AreaType",1,0],[0,"Color",1,0],[1,"Height",0,"Expression",0],[0,"InvertedVolume",1,0],[0,"Layer",1,0],[0,"MoveToNXLayer",1,0],[0,"Name",1,0],[1,"Objects",0,"SelectNXObjectList",0],[0,"Owner",1,0],[0,"Subtype",1,0]],[],[]];
SPLM.PcbExchange.AreaAttributesBuilder = class extends SPLM.Builder{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.PcbExchange.AreaAttributesBuilder";
        SPLM.c$d(this.Class,d);d=[];
    }
};

SPLM.PcbExchange.AreaAttributesBuilder.TypeEnum = Object.freeze({
    "Keepout" : "Keepout", "Keepin" : "Keepin", "Other" : "Other", "Copper" : "Copper"});

SPLM.PcbExchange.AreaAttributesBuilder.OwnerEnum = Object.freeze({
    "Unowned" : "Unowned", "Mcad" : "Mcad", "Ecad" : "Ecad"});

SPLM.PcbExchange.AreaAttributesBuilder.LayerEnum = Object.freeze({
    "Current" : "Current", "Both" : "Both", "Inner" : "Inner", "All" : "All"});

export default SPLM;